import React from 'react';
import PropTypes from 'prop-types';

import { Button, Spinner } from 'react-bootstrap';

import { DATA_SOURCE_RUN_URL, getURL } from 'lib/networking/endpoints';
import useGet from 'lib/hooks/useGet';
import pointerOnHover from 'lib/css/pointerOnHover';

function DataSourceRunURLField({
  dataSourceRunId,
  deltaFile = false,
  errorReport = false,
  label = 'Download Source File',
}) {
  const {
    data: { data: presignedUrl } = {},
    loading,
    refetch,
  } = useGet(
    getURL(DATA_SOURCE_RUN_URL, { data_source_run_id: dataSourceRunId }),
    { deltaFile, errorReport },
    false, // skip
    true, // lazy - this prevents automatic loading
  );

  const handleDownloadClick = () => {
    if (presignedUrl) {
      // If we already have the URL, use it directly
      window.location.href = presignedUrl;
    } else {
      // Fetch the presigned URL and then redirect
      refetch(response => {
        if (response.status === 200 && response.data?.data) {
          window.location.href = response.data.data;
        }
      });
    }
  };

  return (
    <Button
      variant="link"
      className={pointerOnHover}
      onClick={handleDownloadClick}
      disabled={loading}
    >
      {loading ? (
        <>
          <Spinner animation="border" role="status" size="sm" className="me-2">
            <span className="sr-only">Loading...</span>
          </Spinner>
          Loading...
        </>
      ) : (
        label
      )}
    </Button>
  );
}

DataSourceRunURLField.propTypes = {
  dataSourceRunId: PropTypes.number,
  deltaFile: PropTypes.bool,
  errorReport: PropTypes.bool,
  label: PropTypes.string,
};

export default DataSourceRunURLField;
